<template>
  <div id="page">
    <NuxtLayout />
  </div>
</template>
<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

const { locale } = useI18n();

useHead({
  htmlAttrs: {
    lang: computed(() => (locale.value === 'ms-my' ? 'ms-MY' : 'en')),
  },
  script: [
    {
      key: 'scroll-restoration',
      innerHTML: `if('scrollRestoration' in history){history.scrollRestoration='manual';}window.__userHasActivelyScrolled=false;var _u=function(){window.__userHasActivelyScrolled=true;};window.addEventListener('wheel',_u,{passive:true,once:true});window.addEventListener('touchmove',_u,{passive:true,once:true});window.addEventListener('keydown',function(e){if([32,33,34,35,36,38,40].indexOf(e.keyCode)!==-1){_u();}},{passive:true,once:true});var _nav=performance.getEntriesByType&&performance.getEntriesByType('navigation')[0];if((_nav&&_nav.type==='reload')||(performance.navigation&&performance.navigation.type===1)){window.scrollTo(0,0);}`,
      tagPosition: 'head',
    },
  ],
});

onMounted(() => {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  const markUserActive = () => {
    (window as any).__userHasActivelyScrolled = true;
  };

  window.addEventListener('wheel', markUserActive, { passive: true });
  window.addEventListener('touchmove', markUserActive, { passive: true });
  window.addEventListener('keydown', (e) => {
    if (['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Space', 'Home', 'End'].includes(e.code || e.key)) {
      markUserActive();
    }
  }, { passive: true });

  const navEntry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined;
  const isReload = navEntry?.type === 'reload' || (performance as any)?.navigation?.type === 1;

  if (isReload) {
    if (!(window as any).__userHasActivelyScrolled) {
      window.scrollTo(0, 0);
    }
    requestAnimationFrame(() => {
      if (!(window as any).__userHasActivelyScrolled) {
        window.scrollTo(0, 0);
      }
    });
    setTimeout(() => {
      if (!(window as any).__userHasActivelyScrolled && window.scrollY > 0) {
        window.scrollTo(0, 0);
      }
    }, 200);
  }
});
</script>
